import { render } from "./PartsContactIFrame.vue?vue&type=template&id=f51aabc6"
import script from "./PartsContactIFrame.vue?vue&type=script&lang=js"
export * from "./PartsContactIFrame.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maru/Desktop/東野材木/hojokin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__